export var SidenavSubjects;
(function (SidenavSubjects) {
    SidenavSubjects["FixedSidenavContainer"] = "fixed-sidenav-container";
    SidenavSubjects["ExpandedSidenavContainer"] = "expanded-sidenav-container";
    SidenavSubjects["MainItemLinkPrefix"] = "main-item-";
    SidenavSubjects["ExpandedHeaderPlanType"] = "expanded-sidenav-plan-type";
    SidenavSubjects["ExpandedHeaderTitle"] = "expanded-sidenav-title";
    SidenavSubjects["ExpandedHeaderUsername"] = "expanded-sidenav-username";
    SidenavSubjects["ExpandedHeaderRole"] = "expanded-sidenav-role";
    SidenavSubjects["LogoutButton"] = "logout-button";
    SidenavSubjects["SubItemPrefix"] = "side-nav-sub-item-";
    SidenavSubjects["CloseMenu"] = "close-sidenav-menu";
    SidenavSubjects["ThemeSelector"] = "theme-selector";
})(SidenavSubjects || (SidenavSubjects = {}));
export var HeaderSubjects;
(function (HeaderSubjects) {
    HeaderSubjects["TurnOnNewNavigationButton"] = "turn-on-new-navigation";
    HeaderSubjects["PageTitle"] = "header-title";
    HeaderSubjects["Header"] = "header-container";
    HeaderSubjects["HeaderActions"] = "header-actions";
    HeaderSubjects["HelpMenu"] = "help-menu";
    HeaderSubjects["HelpButton"] = "help-button";
    HeaderSubjects["AnnouncementBadge"] = "announcement-badge";
    HeaderSubjects["WhatsNewButton"] = "whats-new";
    HeaderSubjects["WhatsNewContainer"] = "whats-new-container";
    HeaderSubjects["AccountSelectContainer"] = "account-select-container";
    HeaderSubjects["AccountSelect"] = "account-select";
    HeaderSubjects["AccountNameText"] = "logged-in-account-name";
    HeaderSubjects["WhatsNewEmptyState"] = "";
    HeaderSubjects["NotificationBadge"] = "notification-badge";
    HeaderSubjects["LoadingAnnouncements"] = "loading-announcements";
    HeaderSubjects["AnnouncementList"] = "announcements-list";
    HeaderSubjects["WhatsNewSearch"] = "whats-new-search";
    HeaderSubjects["WhatNewEmptyState"] = "whats-new-empty-state";
    HeaderSubjects["CloseWhatsNew"] = "close-whats-new";
    HeaderSubjects["UnreadAnnouncementIndicator"] = "unread-indicator";
    HeaderSubjects["AnnouncementContainer"] = "announcementsContainer";
})(HeaderSubjects || (HeaderSubjects = {}));
export var NavigationSubjects;
(function (NavigationSubjects) {
    NavigationSubjects["SwitchAccountToast"] = "switch-account";
})(NavigationSubjects || (NavigationSubjects = {}));
export var ProductKeys;
(function (ProductKeys) {
    ProductKeys["App360"] = "App360";
    ProductKeys["Home"] = "Home";
    ProductKeys["Spm"] = "Spm";
    ProductKeys["Logs"] = "logsProduct";
    ProductKeys["Metrics"] = "Metrics";
    ProductKeys["Siem"] = "siemProduct";
    ProductKeys["Tracing"] = "tracingProduct";
    ProductKeys["Settings"] = "settings";
    ProductKeys["K8S360"] = "K8S360";
    ProductKeys["Explore"] = "Explore";
    ProductKeys["DataHub"] = "DataHub";
    ProductKeys["Integrations"] = "Integrations";
    ProductKeys["DashboardsHub"] = "DashboardsHub";
    ProductKeys["Alerts"] = "Alerts";
    ProductKeys["None"] = "";
})(ProductKeys || (ProductKeys = {}));
//# sourceMappingURL=navigation.enum.js.map